import React from 'react';
import { Table } from 'antd';

const TotalRowAllFilter = ({ filteredColumns, totalColumns, totals, formatNumber }) => {
    return (
        <Table.Summary.Row className="total-summary-row">
            {filteredColumns.map((column, index) => {
                // Xác định vị trí các cột mốc
                const pricingModelsIndex = filteredColumns.findIndex(col => col.dataIndex === 'Pricingmodels');
                const unitPriceIndex = filteredColumns.findIndex(col => col.dataIndex === 'UnitPrice');

                // Xác định class dựa trên vị trí cột
                let cellClassName = 'summary-cell';
                
                // Hiển thị "Total" cho các cột từ đầu đến Pricing Models
                if (index <= pricingModelsIndex) {
                    cellClassName += ' summary-cell-blue';
                    // Chỉ hiển thị text "Total" ở cột đầu tiên
                    if (index === 0) {
                        return (
                            <Table.Summary.Cell 
                                key="total-label" 
                                index={0}
                                className={cellClassName}
                                colSpan={pricingModelsIndex + 1} // Gộp các cột từ đầu đến Pricing Models
                            >
                                <strong>Total Filter</strong>
                            </Table.Summary.Cell>
                        );
                    }
                    // Bỏ qua các cột đã được gộp
                    if (index < pricingModelsIndex + 1) {
                        return null;
                    }
                } else if (index === unitPriceIndex) {
                    cellClassName += ' summary-cell-normal';
                } else {
                    cellClassName += ' summary-cell-red';
                }

                if (totalColumns.includes(column.dataIndex)) {
                    return (
                        <Table.Summary.Cell
                            key={column.dataIndex}
                            index={column.dataIndex}
                            align="right"
                            className={cellClassName}
                        >
                            {formatNumber(totals[column.dataIndex])}
                        </Table.Summary.Cell>
                    );
                }
                
                return (
                    <Table.Summary.Cell 
                        key={column.dataIndex} 
                        index={column.dataIndex}
                        className={cellClassName}
                    />
                );
            })}
        </Table.Summary.Row>
    );
};

export default TotalRowAllFilter;